var React = require('react');

function GmailInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","d":"M0 0h24v24H0z","key":0}),React.createElement("path",{"d":"M3 3h18a1 1 0 011 1v16a1 1 0 01-1 1H3a1 1 0 01-1-1V4a1 1 0 011-1zm9.06 8.683L5.648 6.238 4.353 7.762l7.72 6.555 7.581-6.56-1.308-1.513-6.285 5.439z","key":1})]);
}

GmailInline.defaultProps = {"viewBox":"0 0 24 24","width":"20","height":"20"};

module.exports = GmailInline;

GmailInline.default = GmailInline;
